"use client";

import { HeroBanner } from "@/features/home/components/HeroBanner";
import { FeaturedBrandsSection } from "@/features/home/components/NewBrandsSection";
import { NewProductsSection } from "@/features/home/components/NewProductsSection";
import { PopularBrandsSection } from "@/features/home/components/PopularBrandsSection";
import { PopularProductsSection } from "@/features/home/components/PopularProductsSection";
import { RecommendedFeed } from "@/features/home/components/RecommendedFeed";
import { TrustBar } from "@/features/home/components/TrustBar";

export function HomeContent() {
  return (
    <div className="flex flex-col">
      {/* ── Curated Sections ── */}
      <HeroBanner />
      <TrustBar />
      <PopularProductsSection />
      <FeaturedBrandsSection />
      <NewProductsSection />
      <PopularBrandsSection />

      {/* ── Infinite Feed ── */}
      <RecommendedFeed />
    </div>
  );
}
